import React from 'react';
import {
	Button,
	Modal, Space, Title,
} from '@components';

import './AboutModal.scss';

interface AboutModalProps {
	closeModal: () => void,
}

function AboutModal(props: AboutModalProps): JSX.Element {
	const {
		closeModal,
	} = props;

	const version = SummeetConfig.version;

	return (
		<Modal isOpen>
			<Space alignment="vertical">
				<Title centered>
					Сведения о cистеме
				</Title>
				<Space alignment="vertical" gap="20px">
					<div>
						<p>Система протоколирования совещаний SumMeet</p><br/>
                        <p>Версия системы: <span className="version" id="summeet_version">%SUMMEET_VERSION_STR%</span></p>
						{version && (
							<p>Версия сервера: <span className="version">{version.database.version}</span></p>
						)}
						{version && version.database.version != version.database.actualVersion && (
							<p>Версия БД: <span className="version">{version.database.actualVersion}</span></p>
						)}
                        <br/><p>© 2021-2022 ООО «ЦИФРОВОЙ ПОМОЩНИК»</p>
					</div>
					<Space centered>
						<Button onClick={closeModal}>
							OK
						</Button><span></span>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export {AboutModal};